export default "<div class=\"row\">\n    <div class=\"col-12 text-center p-4\">\n        <img [src]=\"url\" class=\"img-full\">\n    </div>\n</div>"